/* global Blockly */
import React from 'react';
import util from "../../../../../../utils/es5Utils";

const toggleOn = "data:image/svg+xml,%3Csvg%20width%3D%2728px%27%20height%3D%2728px%27%20viewBox%3D%270%200%2028%2028%27%20version%3D%271.1%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20xmlns%3Axlink%3D%27http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%27%3E%3Ctitle%3Eicon-toggle%20on-SNAP%3C%2Ftitle%3E%3Cg%20id%3D%27icon-toggle-on-SNAP%27%20stroke%3D%27none%27%20stroke-width%3D%271%27%20fill%3D%27none%27%20fill-rule%3D%27evenodd%27%3E%3Crect%20id%3D%27Rectangle%27%20fill%3D%27%23222222%27%20x%3D%272%27%20y%3D%278%27%20width%3D%2724%27%20height%3D%2712%27%20rx%3D%276%27%3E%3C%2Frect%3E%3Ccircle%20id%3D%27Oval%27%20fill%3D%27%23FFFFFF%27%20cx%3D%2720%27%20cy%3D%2714%27%20r%3D%274%27%3E%3C%2Fcircle%3E%3Ctext%20x%3D%225%22%20y%3D%2216%22%20font-family%3D%22Arial%22%20font-size%3D%226%22%20fill%3D%22white%22%3EON%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fsvg%3E";
const toggleOff = "data:image/svg+xml,%3Csvg%20width%3D%2728px%27%20height%3D%2728px%27%20viewBox%3D%270%200%2028%2028%27%20version%3D%271.1%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20xmlns%3Axlink%3D%27http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%27%3E%3Ctitle%3Eicon-toggle%20off-SNAP%3C%2Ftitle%3E%3Cg%20id%3D%27icon-toggle-off-SNAP%27%20stroke%3D%27none%27%20stroke-width%3D%271%27%20fill%3D%27none%27%20fill-rule%3D%27evenodd%27%3E%3Crect%20id%3D%27Rectangle%27%20fill-opacity%3D%270.4%27%20fill%3D%27%23000000%27%20x%3D%272%27%20y%3D%278%27%20width%3D%2724%27%20height%3D%2712%27%20rx%3D%276%27%3E%3C%2Frect%3E%3Ccircle%20id%3D%27Oval%27%20fill%3D%27%23CCCCCC%27%20cx%3D%278%27%20cy%3D%2714%27%20r%3D%274%27%3E%3C%2Fcircle%3E%3Ctext%20x%3D%2219%22%20y%3D%2216%22%20font-family%3D%22Arial%22%20font-size%3D%226%22%20fill%3D%22%23CCCCCC%22%20text-anchor%3D%22middle%22%3EOFF%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fsvg%3E";

export const BLOCK_NAME = 'snap_tableview_refresh_table_V3';

function defineBlock(context) {
    return {
        enableLoader: false,

        init: function () {
            let selectTableDropdown = new Blockly.FieldWidgetsDropdown(context, 'tableview');

            this.appendDummyInput('WIDGET')
                .appendField("refresh table")
                .appendField(selectTableDropdown, "ID");

            this.appendDummyInput("TOGGLE_LOADER")
                .appendField("show loader")
                .appendField(new Blockly.FieldImage(toggleOff, 55, 55, "toggleOff", function () {
                    this.switchLoader(!this.enableLoader);
                }.bind(this)));

            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Refresh TableView widget. When show loader is on, table will refresh while showing a spinning animation.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#Table`);
        },

        switchLoader: function (toggle) {
            this.enableLoader = toggle;
            this.removeInput("TOGGLE_LOADER");
            let image = toggle ? toggleOn : toggleOff;
            this.appendDummyInput("TOGGLE_LOADER")
                .appendField("show loader")
                .appendField(new Blockly.FieldImage(image, 55, 55, toggle ? "toggleOn" : "toggleOff", function () {
                    this.switchLoader(!this.enableLoader);
                }.bind(this)));
            this.initSvg();
            this.render();
        },

        mutationToDom: function () {
            const container = document.createElement('mutation');
            container.setAttribute('enableloader', this.enableLoader);
            return container;
        },

        domToMutation: function (xml) {
            const enableLoader = xml.getAttribute('enableloader');
            if (enableLoader === 'true') {
                this.enableLoader = false;
                this.switchLoader(true);
            }
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let tableViewId = block.getFieldValue('ID');
            let enableLoader = block.enableLoader;
            let code = `Snap.widgets.tableview.refreshTable("${tableViewId}", ${enableLoader});\n`;
            return code;
        }
    }
}

const RefreshTable = function (props) {
    const name = BLOCK_NAME;
    RefreshTable.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return util.widgetsOfType(props.context, "tableview").length ? <block type={name}></block> : null;
}

export default RefreshTable;
